import { SkeletonText, SkeletonTextLine } from '@vp/swan';
import React from 'react';

const PriceLoading = () => {
  return /* @__PURE__ */ React.createElement(SkeletonText, { "aria-label": "loading" }, /* @__PURE__ */ React.createElement(SkeletonTextLine, { width: "narrow" }));
};

export { PriceLoading as default };
//# sourceMappingURL=src-components-PriceLoading.js.map
